import { useContext } from "react";
import { AudioDispatchContext } from "../../audio-dispatch-context";

/**
 * Custom hook for accessing the audio context dispatch function.
 * @returns {object} Audio context dispatch function.
 */
const useAudioDispatch = () => useContext(AudioDispatchContext);

export default useAudioDispatch;
